import { L } from '@lib';
import { LabourOrder } from '@services';
import { Form, FormInstance, Modal, Table } from 'antd';
import React from 'react';
import { EditableCell } from '../EditableCell';
import { LabourColumns } from './LabourTable.columns';

interface IProps {
  hideAction: boolean;
  form: FormInstance<any>;
  dataSource: LabourOrder[];
  editingKey: string;
  showDeleteModal: boolean;
  setShowDeleteModal: (value: boolean) => void;
  isEditing: (record: LabourOrder) => boolean;
  handleCancel: () => void;
  handleDelete: () => void;
  handleDeleteClick: (id: string) => void;
  handleUpdate: (key: React.Key) => Promise<void>;
  handleEdit: (
    record: Partial<LabourOrder> & {
      key: React.Key;
    }
  ) => void;
  handleUpdateExtra: (key: React.Key, parentKey?: React.Key) => void;
}

const LabourTable: React.FC<IProps> = (props) => {
  const { dataSource, showDeleteModal, handleDelete, setShowDeleteModal } = props;
  const showDelete = dataSource.length > 1;

  return (
    <>
      {(dataSource.length && (
        <>
          <b>{L('Description')}</b>
          <Form {...props} component={false}>
            <Table
              {...props}
              style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
              rowKey={(record) => record?.id || ''}
              columns={LabourColumns({ ...props, showDelete })}
              pagination={false}
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
            />
          </Form>
        </>
      )) || <></>}
      <Modal
        onCancel={() => setShowDeleteModal(false)}
        open={showDeleteModal}
        onOk={handleDelete}
        title={L('Are you sure you want to remove this record?')}
      />
    </>
  );
};

export default LabourTable;
